import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import FilterHome from "../../../components/commonComponents/filterHome/FilterHome";
import { ICONS } from "../../../assets/icons";
import { HomeFilterCampaign } from "../../../constant/app/Filter/Filter";
import { conversationPerformanceApi } from "../api/Api";
import { useAspSelector } from "../../../test/jest-redux-hooks";
import { useNavigate } from "react-router-dom";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const Chart = ({ campaignPerformanceList, setCampaignCount }) => {
  const navigate = useNavigate();
 

  const labels = campaignPerformanceList?.map((item) => {
    const name = item?.campaign_name || "";
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  });

  const sentCount = campaignPerformanceList?.map(
    (item) => item?.sent_count || 0
  );

  const deliveredCount =
    campaignPerformanceList?.map((item) => item?.delivered_count || 0) || []; // Default to empty array if undefined

  const openedCount =
    campaignPerformanceList?.map((item) => item?.opened_count || 0) || [];

  const bouncedCount =
    campaignPerformanceList?.map((item) => item?.bounced_count || 0) || [];

  const paddedDeliveredCount =
    deliveredCount?.length < 4
      ? [...deliveredCount, ...new Array(4 - deliveredCount?.length).fill(0)]
      : deliveredCount;

  const data = {
    labels: labels,
    datasets: [
      {
        label: "Sent",
        data:
          sentCount.length < 4
            ? [...sentCount, ...new Array(4 - sentCount.length).fill(0)]
            : sentCount,
        fill: false,
        backgroundColor: sentCount.map((value) =>
          value === 0 ? "#A175FF" : "#A175FF"
        ),
        borderWidth: 1,
        borderRadius: 4,
      },
      {
        label: "Bounced",
        data:
          bouncedCount.length < 4
            ? [...bouncedCount, ...new Array(4 - bouncedCount.length).fill(0)]
            : bouncedCount,
        fill: false,
        backgroundColor: bouncedCount.map((value) =>
          value === 0 ? "red" : "red"
        ),
        borderWidth: 1,
        borderRadius: 4,
      },
      {
        label: "Delivered",
        data: paddedDeliveredCount,
        fill: false,
        backgroundColor: paddedDeliveredCount?.map((value) =>
          value === 0 ? "#EDAB40" : "#EDAB40"
        ),
        borderWidth: 1,
        borderRadius: 4,
      },
      {
        label: "Opened",
        data:
          openedCount.length < 4
            ? [...openedCount, ...new Array(4 - openedCount.length).fill(0)]
            : openedCount,
        fill: false,
        backgroundColor: openedCount.map((value) =>
          value === 0 ? "#1778F2" : "#1778F2"
        ),
        borderWidth: 1,
        borderRadius: 4,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,

    plugins: {
      legend: {
        position: "bottom",
        pointRadius: 6,
        layout: {
          padding: {
            top: 70,
            bottom: 10,
          },
        },
        labels: {
          type: "category",
          usePointStyle: true,
          pointStyle: "circle",
          padding: 30,
          pointRadius: 10,
        },
      },
      tooltip: {
        mode: "index",
        intersect: false,
        padding: 10,
        callbacks: {
          label: function (tooltipItem) {
            const value = tooltipItem.raw; // Get the value of the current item
            if (value === 0) {
              return null; // Hide this item from the tooltip
            }
            // Customize the label as needed
            return `${tooltipItem.dataset.label}: ${value}`;
          },
        },
      },
    },

    barPercentage: 0.9,
    categoryPercentage: 0.13,
    scales: {
      x: {
        grid: {
          color: "#E8E8EA",
          borderColor: "#E8E8EA",
        },
        ticks: {
          font: {
            size: 16,
            weight: "500",
            color: "var(--font-600)",
          },
          callback: function (value, index, ticks) {
            let label = this.chart.data.labels[index];
            return label.length > 10 ? label.substring(0, 10) + "..." : label;
          },

          render: function (value, index, ticks) {
            const labels = this.chart.data.labels;
          },
          padding: 1,
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          color: "#E8E8EA",
          borderColor: "#E8E8EA",
        },

        ticks: {
          stepSize: 2,
          font: {
            size: 16,
            weight: "500",
            color: "var(--font-600)",
          },

          callback: function (value) {
            if (value >= 1000) {
              return `${value / 1000}k`;
            }
            return value;
          },
          maxTicksLimit: 10,
        },
      },
    },
  };

  return (
    // <div className="bg-white rounded-[1vw] px-[2vw] py-[1vw] w-100">
    //   <div className="flex-row justify-between items-center pb-4">
    //     <p className="flex-row items-center text-[1.09rem] font-[500]">
    //       Conversation Performance
    //       <div
    //         className="ml-2 pointer"
    //         onClick={() => navigate("/user/campaign/all-campaigns")}
    //       >
    //         <img src={ICONS?.homeDownload} className="w-[18px] h-[18px]" />
    //       </div>
    //     </p>

    //     <FilterHome
    //       filterList={HomeFilterCampaign}
    //       fetchApiByFilter={handleFilterChange}
    //     />
    //   </div>

      <div style={{ height: "35vh", padding: "0vw 1vw" }}>
        {campaignPerformanceList?.length > 0 ? (
          <Bar data={data} options={options} />
        ) : (
          <div className="h-full flex flex-col items-center justify-center">
            <img src={ICONS?.noChartData} alt="noChartData" />
            <p className="text-[#616874]">There’s no data yet</p>
          </div>
        )}
      </div>
    // </div>
  );
};

export default Chart;
